import { TranslationMap } from '@trimble-gcs/i18n-types';

export function multiSelectedTranslations() {
  return {
    title: {
      text: $localize`:@@recycleMultiSelected.title:{count} Selected Items`,
      desc: 'Title of the recycle bin multi-select options panel. The {count} value will always be larger than one.',
    },
    close: {
      tooltip: {
        text: $localize`:@@recycleMultiSelected.close.tooltip:Close`,
        desc: "Tooltip for the top right 'X' button that closes the recycle bin multi-select options panel.",
      },
    },
    size: {
      text: $localize`:@@recycleMultiSelected.size:Total Size`,
      desc: 'Label for the total size of the selected point clouds.',
    },
  } satisfies TranslationMap;
}
